import zod from 'zod';

export const LprDeviceAvailableEvents = zod.enum([
  'TRAFFIC_RUNREDLIGHT',
  'TRAFFICJUNCTION',
  'TRAFFIC_OVERSPEED',
  'TRAFFIC_UNDERSPEED',
  'TRAFFIC_MANUALSNAP',
  'TRAFFIC_PARKINGSPACEPARKING',
  'TRAFFIC_PARKINGSPACENOPARKING',
  'TRAFFIC_OVERLINE',
  'TRAFFIC_RETROGRADE',
  'TRAFFIC_PARKING',
  'TRAFFIC_WRONGROUTE',
  'TRAFFIC_CROSSLANE',
  'TRAFFIC_OVERYELLOWLINE',
  'TRAFFIC_YELLOWPLATEINLANE',
  'TRAFFIC_PEDESTRAINPRIORITY',
  'TRAFFIC_VEHICLEINROUTE',
  'TRAFFIC_VEHICLEINBUSROUTE',
  'TRAFFIC_BACKING',
  'TRAFFIC_WITHOUT_SAFEBELT',
]);

export const LprDeviceConfigEditionFormSchema = zod.object({
  maxSpeed: zod.number().optional(),
  isOnlyPlate: zod.boolean().optional(),
  telegramIds: zod.array(zod.string()).optional(),
  whatsAppNumbers: zod.array(zod.string()).optional(),
  emailAddresses: zod.array(zod.string().max(254).email()).optional(),
  smtpIntegrationId: zod.number().optional().nullable(),
  isNotifyLogEvent: zod.boolean(),
  isNotifyEvenWithoutGroups: zod.boolean(),
});
